{
  "processing": "Memproses pengesahan...",
  "loadingIframe": "Memuatkan pengesahan ID...",
  "issueTitle": "Isu Pengesahan ID",
  "notConfigured": "Pengesahan ID tidak dikonfigurasikan dengan betul untuk gudang ini.",
  "notSuccessful": "Pengesahan ID tidak berjaya. Sila cuba lagi atau hubungi gudang.",
  "couldNotCompleteProceed": "Pengesahan ID tidak dapat diselesaikan, tetapi anda boleh meneruskan dengan daftar masuk.",
  "processFailed": "Gagal memproses pengesahan ID. Sila cuba lagi.",
  "processingFailedProceed": "Pemprosesan pengesahan ID gagal, tetapi anda boleh meneruskan dengan daftar masuk.",
  "genericError": "Ralat berlaku semasa pengesahan ID. Sila cuba lagi.",
  "issueProceed": "Pengesahan ID mengalami isu, tetapi anda boleh meneruskan dengan daftar masuk.",
  "requiredTryAgain": "Pengesahan ID diperlukan untuk melengkapkan daftar masuk. Sila cuba lagi.",
  "checkInFailedTitle": "Tidak dapat daftar masuk",
  "checkInFailedMessage": "ID anda tidak dapat disahkan"
}
